import {Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, ViewChild} from '@angular/core';
import {ProjectConstants} from '../../project-constants';
import {MatDialog, MatPaginator, MatSort, MatTableDataSource, PageEvent, Sort} from '@angular/material';
import {Subscription} from 'rxjs';
import {Offset} from '../../../models/Offset';
import * as servers from '../../../services/api/servers';
import {urls} from '../../../services/api/urls';
import {GenericArray} from '../../../models/GenericArray';
import {DialogDetailComponent} from '../../general-components/dialog-detail/dialog-detail.component';
import {DesignServicesModel} from '../../../models/DesignServicesModel';
import * as toastr from 'toastr';
import {RegionModel} from '../../../models/RegionModel';
import {ContractTypeModel} from '../../../models/ContractTypeModel';
import {ResourcesUnitModel} from '../../../models/ResourcesUnitModel';
import {LocalCustomerModel} from '../../../models/LocalCustomerModel';
import {AllSettingsFilterModel} from '../../../models/AllSettingsFilterModel';
import {CurrencyModel} from '../../../models/CurrencyModel';
import {ProviderModel} from '../../../models/ProviderModel';
import {Router} from '@angular/router';
import {LoaderService} from '../../general-services/service-loader/loader.service';
import {Sl1AnagrafService} from '../../general-services/service-sl1-services/sl1-anagraf.service';

@Component({
  selector: 'app-design-services-anagraf',
  templateUrl: './sl1-anagraf.component.html',
  styleUrls: ['./sl1-anagraf.component.scss']
})
export class Sl1AnagrafComponent extends ProjectConstants implements OnInit, OnDestroy, OnChanges {

  displayedColumns: Array<string>;
  dataSource: any;
  designServicesUrl: string;
  selectedRowIndex: number;
  isMocked: boolean;
  isAnagraphSection: boolean;
  listData: MatTableDataSource<any>;
  getPageSubscribe: Subscription;
  deleteElementSubscribe: Subscription;
  offset: Offset;
  pageSize: number;
  filter: DesignServicesModel;
  filterAllInSettings: AllSettingsFilterModel;

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @Input() showActions?: boolean;
  @Input() inAllSettings?: boolean;
  @Input() idSelected?: number;
  @Input() regionForFilterInSettings?: RegionModel;
  @Input() localCustomerForFilterInSettings?: LocalCustomerModel;
  @Input() contractTypeForFilterInSettings?: ContractTypeModel;
  @Input() resourceUnitForFilterInSettings?: ResourcesUnitModel;
  @Input() currencyForFilterInSettings?: CurrencyModel;
  @Input() providerForFilterInSettings?: ProviderModel;

  @Output() elementSelected = new EventEmitter();



  constructor(private sl1ServicesService: Sl1AnagrafService,
              private dialog: MatDialog,
              private loaderService: LoaderService,
              private router: Router) {
    super();
    this.isAnagraphSection = ProjectConstants.returnIsAnagraphSection(this.router.url);
    this.designServicesUrl = servers.apiUrl + urls.cobidbService + urls.sl1;
    this.showActions = true;
    this.inAllSettings = false;
    this.selectedRowIndex = -1;
    this.filter = new DesignServicesModel();
  }

  ngOnChanges (changes: SimpleChanges) {
    if ('regionForFilterInSettings' in changes ||
      'contractTypeForFilterInSettings' in changes ||
      'resourceUnitForFilterInSettings' in changes ||
      'localCustomerForFilterInSettings' in changes ||
      'currencyForFilterInSettings' in changes ||
      'providerForFilterInSettings' in changes) {
      this.resetTable();
    }
  }

  ngOnInit() {
    this.isMocked = false;
    if (this.showActions === true) {
      this.displayedColumns = ['designServicesCod', 'designServicesDesc', 'inArchStructSett', 'actions'];
    } else {
      this.selectedRowIndex = this.idSelected;
      this.displayedColumns = ['designServicesCod', 'designServicesDesc'];
    }

    this.pageSize = 10;
    this.setOffsetInSession();
    this.getAll(this.offset);
  }

  getAll(offset: Offset) {
    this.loaderService.display(true);
    if (this.isMocked) {
      this.listData = new MatTableDataSource(this.dataSource);
      this.listData.paginator = this.paginator;
      this.listData.sort = this.sort;
    } else {
      if (this.inAllSettings) {
        this.filterAllInSettings = new AllSettingsFilterModel();

        this.filterAllInSettings.region = this.regionForFilterInSettings;
        this.filterAllInSettings.resourceUnit = this.resourceUnitForFilterInSettings;
        this.filterAllInSettings.localCustomer = this.localCustomerForFilterInSettings;
        this.filterAllInSettings.provider = this.providerForFilterInSettings;
        this.filterAllInSettings.contractType = this.contractTypeForFilterInSettings;
        this.filterAllInSettings.sl1 = this.filter;

        this.getPageSubscribe = this.sl1ServicesService.getPageInAllSettings(offset, this.filterAllInSettings)
          .subscribe(
            (result: any) => {
              this.dataSource = result.content;
              this.listData = new MatTableDataSource(this.dataSource);
              this.paginator.pageIndex = offset.pageIndex;
              this.paginator.showFirstLastButtons = true;
              this.paginator.length = result.totalElements;
              this.loaderService.display(false);
            });
      } else {
        this.getPageSubscribe = this.sl1ServicesService.getPage(offset, this.filter)
          .subscribe(
            (result: any) => {
              this.dataSource = result.content;
              this.listData = new MatTableDataSource(this.dataSource);
              this.paginator.pageIndex = offset.pageIndex;
              this.paginator.showFirstLastButtons = true;
              this.paginator.length = result.totalElements;
              this.loaderService.display(false);
            });
      }
    }
  }
  filterTable() {
    this.getAll(this.offset);
  }

  resetTable() {
    this.filter = new DesignServicesModel();
    this.getAll(new Offset(10, 0));
  }
  openDialog(id: number) {
    const designData = this.dataSource.find(data => data.id === id) as DesignServicesModel;
    const list: GenericArray[] = [
      { id: 'SL1 Cod', value: designData.cod.toString() },
      { id: 'SL1 Description', value: designData.description.toString()}
    ];
    const dialogRef = this.dialog.open(DialogDetailComponent, {
      width: '40%',
      data: {list}
    });

    dialogRef.afterClosed().subscribe(result => {
      // console.log('The dialog was closed');
    });

  }

  getNext(event: PageEvent) {
    this.loaderService.display(true);
    const tmpOffset = new Offset(event.pageSize, event.pageIndex);
    this.setOffsetInSession(tmpOffset);
    tmpOffset.orderDirection = this.offset.orderDirection;
    tmpOffset.orderField = this.offset.orderField;
    this.offset = tmpOffset;
    this.getAll(this.offset);

  }

  deleteElement(id: number) {
    if (confirm('Are you sure do you want to delete?')) {
      this.deleteElementSubscribe = this.sl1ServicesService.softDelete(id)
        .subscribe(
          (result: any) => {
            if (result) {
              toastr.success('SL1 with id ' + id + ' was deleted with success', 'Success');
              this.getAll(this.offset);
            } else {
              toastr.info('SL1 cannot be deleted', 'Alert');
            }

          }, error => {
            toastr.error('SL1 with id ' + id + ' was not deleted', 'Error');
          }
        );
    }
  }

  getDataFiltered(dataFiltered: any) {
    console.log(dataFiltered);
    if (this.offset === null || this.offset === undefined) {
      this.offset = new Offset(10, 0);
    }
    this.dataSource = dataFiltered.content;
    this.listData = new MatTableDataSource(this.dataSource);
    this.paginator.pageIndex = this.offset.pageIndex;
    this.paginator.length = dataFiltered.totalElements;

  }

  sortData(sort: Sort) {
    this.loaderService.display(true);
    if ((sort.active !== null || true || sort.active !== '') && (sort.direction !== '' || sort.direction !== null || true)) {
      if (this.offset === null || this.offset === undefined) {
        this.offset = new Offset(10, 0);
      }

      this.offset.orderField = sort.active;
      this.offset.orderDirection = sort.direction;

      this.getAll(this.offset);
    }
  }

  ngOnDestroy(): void {
    if (this.getPageSubscribe) {
      this.getPageSubscribe.unsubscribe();
    }
    if (this.deleteElementSubscribe) {
      this.deleteElementSubscribe.unsubscribe();
    }
  }

  selectRow(row: any) {
    this.selectedRowIndex = row.id;
    this.elementSelected.emit({ row });
  }

  setOffsetInSession(newOffset?: Offset) {
    if (newOffset) {
      sessionStorage.setItem('sl1Offset', JSON.stringify(newOffset));
    } else {
      const sessionOffset = sessionStorage.getItem('sl1Offset');
      this.offset = sessionOffset !== 'undefined' && sessionOffset !== null ? JSON.parse(sessionOffset) : new Offset(10, 0);
      this.pageSize = this.offset.pageSize;
    }
  }

}
